import styled, { css } from 'styled-components'
import IconOrder from '../../../assets/img/icon-order.svg'

export const Wrapper = styled.div``

export const TableDesktop = styled.table`
  ${({ theme, show }) => css`
    width: 100%;
    border-radius: 4px;
    background: #fff;
    text-align: center;
    border-collapse: collapse;
    overflow: hidden;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);

    /* TABLE HEADER */

    thead tr {
      background: #f1f2f2;
    }

    thead th {
      font-weight: bold;
      font-size: 14px;
      vertical-align: middle;
      padding: 20px;
      cursor: pointer;

      i {
        position: absolute;
        margin-left: 5px;
        background-color: #000000;
      }

      &.sortable:active {
        background: #ddd;
      }

      &.sortable::after {
        content: '';
        background: url(${IconOrder});
        filter: brightness(0%);
        width: 18px;
        height: 18px;
        position: absolute;
        margin-left: 5px;
        background-repeat: no-repeat;
      }

      @media (max-width: ${theme.media.ipad}) {
        padding: 20px 10px;
      }
    }

    thead th:nth-child(2) {
      text-align: left;
    }

    &.table-primary {
      border-radius: 0px;

      thead tr {
        background: ${theme.colors.primary};
      }

      thead th {
        color: #ffffff;
        padding: 20px;

        i {
          background-color: #ffffff;
        }
      }
    }

    /* TABLE BODY */

    tbody tr {
      &:nth-of-type(4n + 3) {
        background: #f1f2f2;
      }
    }

    tbody td {
      font-size: 14px;
      padding: 15px 12px;
      vertical-align: middle;

      &.description {
        text-align: left;
      }

      .link {
        float: right;
        margin: 0;
        padding: 0;
        color: #4a4a4a;
        font-size: 100%;
        background: transparent;
        vertical-align: baseline;
        border: none;
        cursor: pointer;
      }

      .detail-arrow {
        /* margin-right: 8px; */

        img {
          width: 11px;
          height: 11px;
          transition: all 400ms;
        }
      }

      .detail-arrow-desk {
        width: 11px;
        height: 11px;
        margin-left: 4px;
        transition: all 400ms;
      }

      .text-color-green {
        color: ${theme.colors.success};
      }
      .text-color-red {
        color: ${theme.colors.error};
      }

      @media (min-width: ${theme.media.desktop}) {
        .detail-arrow {
          display: none;
        }
      }

      @media (max-width: ${theme.media.ipad}) {
        padding: 15px 10px;
        padding-right: 20px;
      }
    }

    tbody td:nth-child(2) {
      text-align: left;
    }

    // Não exibir campos em mobile
    .mobile-view {
      @media (max-width: ${theme.media.ipad}) {
        display: none;
      }
    }
  `}
`

export const Badge = styled.span`
  ${({ theme, type }) => css`
    display: inline-block;
    border-radius: 4px;
    text-transform: capitalize;
    font-size: 10px;
    font-weight: bold;
    padding: 6px 10px;

    ${type === 'CRÉDITO' &&
    css`
      color: #ffffff;
      background: ${theme.colors.success};
    `}

    ${type === 'DÉBITO' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}
  `}
`

export const Details = styled.tr`
  ${({ theme, show }) => css`
    display: none;
    text-align: left;
    border-bottom: 0.5px solid #c5c5c5;

    ${show &&
    css`
      display: table-row;
    `}

    &:last-child {
      border: 0;
    }

    ul {
      list-style-type: none;
      align-items: center;
      position: relative;

      li {
        margin-bottom: 10px;
        margin-left: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    div a button.link-pedido-mobile {
      font-size: 16px;
      position: absolute;
      right: 16px;
      top: 30px;

      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      img {
        width: 24px;
      }
    }
    // EXIBIR DETALHES APENAS EM MOBILE
    @media (min-width: ${theme.media.desktop}) {
      /* display: none; */
      ul {
        display: flex;
        justify-content: center;
        align-items: center;

        li {
          margin-bottom: 0;
        }

        div button.link-pedido {
          font-size: 16px;
        }
      }
    }
  `}
`
